import Vue from 'vue'
import VueRouter from 'vue-router'
import { Capacitor } from '@capacitor/core'
import { canNavigate } from '@/plugins/acl/routeProtection'

Vue.use(VueRouter)

const isNativeApp = () => Boolean(Capacitor?.isNativePlatform?.())

const routes = [
  {
    path: '/agora',
    name: 'agora',
    component: () => import('@/views/Register/Service/_components/agora.vue'),
    meta: {
      layout: 'blank',
    },
  },

  {
    path: '/',
    name: 'landingPage',
    component: () => import('@/views/LandingPage/LandingPage.vue'),
    beforeEnter: (to, from, next) => {
      if (isNativeApp()) {
        next({ name: 'auth-login' })
      } else {
        next()
      }
    },
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/landingPage/:policy',
    name: 'policy',
    component: () => import('@/views/LandingPage/LandingPage.vue'),
    beforeEnter: (to, from, next) => {
      if (isNativeApp()) {
        next({ name: 'auth-login' })
      } else {
        next()
      }
    },
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/Dashboard/Dashboard.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'Public',
    },
  },

  // Register
  {
    path: '/customer',
    name: 'customer',
    component: () => import('@/views/Register/Customer/Customer.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'Customer',
    },
  },
  {
    path: '/supplier',
    name: 'supplier',
    component: () => import('@/views/Register/Supplier/Supplier.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'Supplier',
    },
  },
  {
    path: '/employee',
    name: 'employee',
    component: () => import('@/views/Register/Employee/Employee.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'Employee',
    },
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('@/views/Register/Product/Product.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'Product',
    },
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('@/views/Register/Service/Service.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'Service',
    },
  },
  {
    path: '/card',
    name: 'card',
    component: () => import('@/views/Register/Card/Card.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'Card',
    },
  },
  {
    path: '/pizza_catalog',
    name: 'pizza_catalog',
    component: () => import('@/views/DeliveryCenter/PizzaRegister/PizzaRegister.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'Sales',
    },
  },

  // Agenda

  {
    path: '/calendar',
    name: 'calendar',
    component: () => import('@/views/Calendar/Calendar.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'Calendar',
    },
  },
  // link para o calendario de agendamento cliente final
  {
    path: '/schedule/:hash',
    name: 'calendar/schedule',
    component: () => import('@/views/ScheduleCustomer/ScheduleCustomer.vue'),
    meta: {
      layout: 'blank',

    },
  },
  //painel cozinha
  {
    path: '/menu/kitchen/:hash',
    name: 'external_menu/kitchen',
    component: () => import('@/views/Sales/NewSales/_components/PdvTable/KitchenPanel.vue'),
    
    meta: {
      layout: 'blank',
    },
  },
  // link para o atendimento nas mesas
  {
    path: '/menu/waiter/:hash',
    name: 'external_menu/waiter',
    component: () => import('@/views/Sales/NewSales/_components/PdvTable/Waiter.vue'),
    
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/menu/table/pizza/:hash',
    name: 'table-order-pizza',
    component: () => import('@/views/DeliveryCenter/DeliveryExternalPizza/DeliveryExternalPizza.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/menu/table/products/:hash',
    name: 'table-order-products',
    component: () => import('@/views/ExternalMenu/ExternalMenu.vue'),
    meta: {
      layout: 'blank',
    },
  },
  // link para o menu externo
  {
    path: '/menu/:company/:hash',
    name: 'external_menu/company',
    component: () => import('@/views/ExternalMenu/ExternalMenu.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/menu/pizza/:company/:hash',
    name: 'external_menu/pizza',
    component: () => import('@/views/DeliveryCenter/DeliveryExternalPizza/DeliveryExternalPizza.vue'),
    meta: {
      layout: 'blank',
    },
  },
  
  {
    path: '/menu/:hash',
    name: 'external_menu/menu',
    component: () => import('@/views/ExternalMenu/ExternalMenu.vue'),
    meta: {
      layout: 'blank',

    },
  },

  // Finaceiro
  {
    path: '/financial/Expense',
    name: 'financial/expense',
    component: () => import('@/views/Financial/Expenses/BillsToPay.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'FinancialExpense',
    },
  },
  {
    path: '/financial/revenue',
    name: 'financial/revenue',
    component: () => import('@/views/Financial/Revenue/Revenue.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'FinancialRevenue',
    },
  },
  {
    path: '/financial/invoice',
    name: 'financial/invoice',
    component: () => import('@/views/Financial/Invoice/Invoice.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'FinancialCashFlow',
    },
  },

  {
    path: '/financial/cash_flow',
    name: 'financial/cash_flow',
    component: () => import('@/views/Financial/CashFlow/CashFlow.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'FinancialCashFlow',
    },
  },
  {
    path: '/financial/cash_flow/report',
    name: 'financial/cash_flow_report',
    component: () => import('@/views/Report/Financial/CashFlow/Report.vue'),
    meta: {
      layout: 'content',
    },
  },

  // },
  // {
  //   path: '/financial/paid_bills_bills_to_pay/:paid_bills',
  //   name: 'financial/paid_bills_bills_to_pay',
  //   component: () => import('@/views/Financial/PaidBills_BillsToPay.vue'),
  //   meta: {
  //     layout: 'content',
  //   },
  // },
  // {
  //   path: '/financial/add_bills_to_pay/:paid_bills',
  //   name: 'financial/add_bills_to_pay',
  //   component: () => import('@/views/Financial/AddBillsToPay.vue'),
  //   meta: {
  //     layout: 'content',
  //   },
  // },

  // Marketing
  {
    path: '/marketing',
    name: 'marketing',
    component: () => import('@/views/Marketing/Marketing.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/marketing/offers',
    name: 'marketing/offers',
    component: () => import('@/views/Marketing/Offers/Offers.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'Marketing',
    },
  },

  // SALARIOS E COMMISSOES


  {
    path: '/customize_commission',
    name: 'customize_commission',
    component: () => import('@/views/SalaryAndCommission/CustomizeCommission/CustomizeCommission.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/report_anticipation',
    name: 'report_anticipation',
    component: () => import('@/views/SalaryAndCommission/ReportAnticipation/ReportAnticipation.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/pay_professional',
    name: 'pay_professional',
    component: () => import('@/views/SalaryAndCommission/PayProfessional/PayProfessional.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'TeamPayment',
    },
  },
  {
    path: '/turno_programado',
    name: 'turno_programado',
    component: () => import('@/views/SalaryAndCommission/TurnoProgramado/TurnoProgramado.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'ScheduledShift',
    },
  },
  {
    path: '/controle_ponto',
    name: 'controle_ponto',
    component: () => import('@/views/SalaryAndCommission/ControlePonto/ControlePonto.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'PointControl',
    },
  },

  // STOCK
  {
    path: '/stock/stock',
    name: 'stock/stock',
    component: () => import('@/views/Stock/Stock/Stock.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'Stock',
    },
  },
  {
    path: '/stock/purchase_orders',
    name: 'stock/purchase_orders',
    component: () => import('@/views/Stock/PurchaseOrder/PurchaseOrder.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'StockPurchase',
    },
  },
  {
    path: '/stock/purchase_entry',
    name: 'stock/purchase_entries',
    component: () => import('@/views/Stock/PurchaseEntry/PurchaseEntry.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'StockPurchase',
    },
  },

  // extrato de lacamento de produtos
  {
    path: '/stock/extract_product',
    name: 'stock/extract_product',
    component: () => import('@/views/Stock/Stock/components/ExtractProduct.vue'),
    meta: {
      layout: 'content',
    },
  },

  // {
  //   path: '/stock/purchase_stock/:action',
  //   name: 'stock/purchase_stock',
  //   component: () => import('@/views/Stock/PurchaseStock.vue'),
  //   meta: {
  //     layout: 'content',
  //   },
  // },
  // {
  //   path: '/stock/movement_stock/:action',
  //   name: 'stock/movement_stock',
  //   component: () => import('@/views/Stock/MovementStock.vue'),
  //   meta: {
  //     layout: 'content',
  //   },
  // },
  {
    path: '/cash_open',
    name: 'cash_open',
    component: () => import('@/views/Cash/CashOpen.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'Cash',
    },
  },
  {
    path: '/cash_close',
    name: 'cash_close',
    component: () => import('@/views/Cash/CashClose.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/cash',
    name: 'cash',
    component: () => import('@/views/Cash/Cash.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/cash/pdv',
    name: 'cash/pdv',
    component: () => import('@/views/Cash/PDV/PDV.vue'),
    meta: {
      layout: 'content',
    },
  },

  // Vendas
  {
    path: '/new_sales',
    name: 'new_sales',
    component: () => import('@/views/Sales/NewSales/NewSales.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/sales',
    name: 'sales',
    component: () => import('@/views/Sales/Sales/Sales.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'SalesView',
    },
  },
  {
    path: '/daily_sales',
    name: 'daily_sales',
    component: () => import('@/views/Sales/DailySales/DailySales.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'Sales',
    },
  },
  {
    path: '/payments_sales',
    name: 'payments_sales',
    component: () => import('@/views/Sales/PaymentsSales/PaymentsSales.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'SalesView',
    },
  },
  {
    path: '/ponto_de_venda',
    name: 'ponto_de_venda',
    component: () => import('@/views/Sales/PointOfSale/PointOfSale.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'Sales',
    },
  },
  {
    path: '/ponto_de_venda/mercado',
    name: 'sale_market',
    component: () => import('@/views/Sales/SaleMarket/SaleMarket.vue'),
    meta: {
      layout: 'blank',
      action: 'read',
      resource: 'Sales',
    },
  },
  {
    path: '/auto_atendimento',
    name: 'auto_atendimento',
    component: () => import('@/views/Sales/SelfServiceScreen/SelfServiceScreen.vue'),
    meta: {
      layout: 'blank',
      action: 'read',
      resource: 'Sales',
    },
  },
  {
    path: '/delivery_center',
    name: 'delivery_center',
    component: () => import('@/views/DeliveryCenter/DeliveryCenter/DeliveryCenter.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'Sales',
    },
  },
  {
    path: '/delivery_history',
    name: 'delivery_history',
    component: () => import('@/views/DeliveryCenter/DeliveryHistory/DeliveryHistory.vue'), 
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'Sales',
    },
  },

  // Relatório
  {
    path: '/system/report/calendar',
    name: 'system/report/calendar',
    component: () => import('@/views/Report/Calendar/CalendarReport.vue'),
    meta: {
      layout: 'content',
    },
  },

  {
    path: '/system/report',
    name: 'system/report',
    component: () => import('@/views/Report/Report.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'Reports',
    },
  },
  {
    path: '/system/report/customer/list_customer',
    name: 'system/report/customer/list_customer',
    component: () => import('@/views/Report/Schedule/ScheduleList/ScheduleList.vue'),

    meta: {
      layout: 'content',
    },
  },

  //relatorios de stock
  {
    path: '/system/report/stock/stock_available',
    name: 'system/report/stock/stock_available',
    component: () => import('@/views/Report/Stock/StockAvailable/StockAvailable.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/system/report/stock/stock_movement_summary',
    name: 'system/report/stock/stock_movement_summary',
    component: () => import('@/views/Report/Stock/StockMovementSummary/StockMovementSummary.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/system/report/stock/stock_movement_register',
    name: 'system/report/stock/stock_movement_register',
    component: () => import('@/views/Report/Stock/StockMovementRegister/StockMovementRegister.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/system/report/stock/stock_product_list',
    name: 'system/report/stock/stock_product_list',
    component: () => import('@/views/Report/Stock/StockProductList/StockProductList.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/system/report/stock/stock_orders',
    name: 'system/report/stock/stock_orders',
    component: () => import('@/views/Report/Stock/StockOrder/StockOrder.vue'),
    meta: {
      layout: 'content',
    },
  },

  //RELATORIOS DE VENDAS

  //relatorio de resumo de vendas
  {
    path: '/system/report/sale/summary_sale',
    name: 'system/report/sale/summary_sale',
    component: () => import('@/views/Report/Sale/ReportSummarySale/ReportSummarySale.vue'),
    meta: {
      layout: 'content',
    },
  },
  //relatorio lista de vendas
  {
    path: '/system/report/sale/list_sale',
    name: 'system/report/sale/list_sale',
    component: () => import('@/views/Report/Sale/ReportListSale/ReportListSale.vue'),
    meta: {
      layout: 'content',
    },
  },

  //RELATORIOS FINANCEIROS
  //relatorio resumo de fincaceiro
  {
    path: '/system/report/financial/report_summary_financial',
    name: 'system/report/financial/report_summary_financial',
    component: () => import('@/views/Report/Financial/ReportSummaryFinancial/ReportSummaryFinancial.vue'),
    meta: {
      layout: 'content',
    },
  },

  //relatorio resumo de pagamentos
  {
    path: '/system/report/financial/report_summary_payment',
    name: 'system/report/financial/report_summary_payment',
    component: () => import('@/views/Report/Financial/ReportSummaryPayment/ReportSummaryPayment.vue'),
    meta: {
      layout: 'content',
    },
  },
  //relatorio de transações de pagamentos
  {
    path: '/system/report/financial/report_payment',
    name: 'system/report/financial/report_payment',
    component: () => import('@/views/Report/Financial/ReportPayment/ReportPayment.vue'),
    meta: {
      layout: 'content',
    },
  },


  //relatorio de extrato do fluxo de caixa
  {
    path: '/system/report/financial/report_cash_flow/:type',
    name: 'system/report/financial/report_cash_flow',
    component: () => import('@/views/Report/Financial/CashFlow/Report.vue'),
    meta: {
      layout: 'content',
    },
  },


  // relatorio lsta de agendamentos
  {
    path: '/system/report/schedule/list_schedule',
    name: 'system/report/schedule/list_schedule',
    component: () => import('@/views/Report/Schedule/ScheduleList/ScheduleList.vue'),
    meta: {
      layout: 'content',
    },
  },

  // resumo de agendamentos
  {
    path: '/system/report/schedule/schedule_summary',
    name: 'system/report/schedule/schedule_summary',
    component: () => import('@/views/Report/Schedule/ScheduleSummary/ScheduleSummary.vue'),
    meta: {
      layout: 'content',
    },
  },

  // resumo de agendamentos cancelados
  {
    path: '/system/report/schedule/schedule_summary_canceled',
    name: 'system/report/schedule/schedule_summary_canceled',
    component: () => import('@/views/Report/Schedule/ScheduleSummaryCanceled/ScheduleSummaryCanceled.vue'),
    meta: {
      layout: 'content',
    },
  },

  //Relatorios de equipe
  // ralatorio atividades de commissoao
  {
    path: '/report_commission',
    name: 'report_commission',
    component: () => import('@/views/Report/Team/ReportCommission/ReportCommission.vue'),
    meta: {
      layout: 'content',
    },
  },

  // realtorio resumo das commissoes
  {
    path: '/report_commission_summary',
    name: 'report_commission_summary',
    component: () => import('@/views/Report/Team/CommissionsSummary/CommissionSummary.vue'),

    meta: {
      layout: 'content',
    },
  },
  //relatorio historico de horas trabalhadas
  {
    path: '/system/report/team/report_historic_hours_worked',
    name: 'report_historic_hours_worked',
    component: () => import('@/views/Report/Team/ReportHistoricHoursWorked/ReportHistoricHoursWorked.vue'),
    meta: {
      layout: 'content',
    },
  },

  //relatorio detalhe do salario
  {
    path: '/system/report/team/report_salary_details',
    name: 'report_salary_details',
    component: () => import('@/views/Report/Team/ReportSalaryDetails/ReportSalaryDetails.vue'),
    meta: {
      layout: 'content',
    },
  },

  //relatorio resumo de frequencia
  {
    path: '/system/report/team/report_summary_frequency',
    name: 'report_summary_frequency',
    component: () => import('@/views/Report/Team/ReportSummaryFrequency/ReportSummaryFrequency.vue'),
    meta: {
      layout: 'content',
    },
  },

  //relatorio resumo de gorjetas
  {
    path: '/system/report/team/report_summary_gratuity',
    name: 'report_summary_gratuity',
    component: () => import('@/views/Report/Team/ReportSummaryGratuity/ReportSummaryGratuity.vue'),
    meta: {
      layout: 'content',
    },
  },

  //relatorio registro de gorjetas
  {
    path: '/system/report/team/report_gratuity',
    name: 'report_gratuity',
    component: () => import('@/views/Report/Team/ReportGratuity/ReportGratuity.vue'),
    meta: {
      layout: 'content',
    },
  },

  //relatorio resumo de produtividade
  {
    path: '/system/report/team/report_summary_productivity',
    name: 'report_productivity_summary',
    component: () => import('@/views/Report/Team/ReportSummaryProdutivity/ReportSummaryProdutivity.vue'),


    meta: {
      layout: 'content',
    },
  },

  //relatorio de folgas
  {
    path: '/system/report/team/report_slack',
    name: 'report_slack',
    component: () => import('@/views/Report/Team/ReportSlack/ReportSlack.vue'),
    meta: {
      layout: 'content',
    },
  },


  //relatorio resumo do salario
  {
    path: '/system/report/team/report_summary_payment',
    name: 'report_summary_payment',
    component: () => import('@/views/Report/Team/ReportSummaryPayment/ReportSummaryPayment.vue'),
    meta: {
      layout: 'content',
    },
  },
  //relatorio resumo do payment
  {
    path: '/system/report/team/report_summary_salary',
    name: 'report_summary_salary',
    component: () => import('@/views/Report/Team/ReportSummarySalary/ReportSummarySalary.vue'),
    meta: {
      layout: 'content',
    },
  },

  //relatorio turnos programados
  {
    path: '/system/report/team/report_scheduled_shifts',
    name: 'report_scheduled_shifts',
    component: () => import('@/views/Report/Team/ReportScheduledShift/ReportScheduledShift.vue'),

    meta: {
      layout: 'content',
    },
  },
  // Painels
  {
    path: '/system/report/panel/performance',
    name: 'report_performance_panel',
    component: () => import('@/views/Report/Panel/PerformacePanel/PanelPerformace.vue'),
    meta: {
      layout: 'content',
    },
  },

  // System
  {
    path: '/system/configuration',
    name: 'system/configuration',
    component: () => import('@/views/Configuration/Configuration.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'Configuration',
    },
  },
  {
    path: '/system/configuration/company',
    name: 'system/configuration/company',
    component: () => import('@/views/Configuration/ConfigCompany/ConfigCompany.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/system/configuration/sale',
    name: 'system/configuration/sale',
    component: () => import('@/views/Configuration/ConfigSales/ConfigSales.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/system/configuration/schedule',
    name: 'system/configuration/schedule',
    component: () => import('@/views/Configuration/ConfigSchedule/ConfigSchedule.vue'),
    meta: {
      layout: 'content',
    },
  }, 
  {
    path: '/system/configuration/delivery',
    name: 'system/configuration/delivery',
    component: () => import('@/views/Configuration/ConfigDelivery/ConfigDelivery.vue'),
    meta: {
      layout: 'content',
    },
  },


  // {
  //   path: '/system/config_gratuity',
  //   name: 'system/config_gratuity',
  //   component: () => import('@/views/System/ConfigGratuity/ConfigGratuity.vue'),
  //   meta: {
  //     layout: 'content',
  //     action: 'read',
  //     resource: 'Configuration',
  //   },
  // },
  {
    path: '/system/access_control',
    name: 'system/access_control',
    component: () => import('@/views/System/AccessControl/AccessControl.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'AccessControl',
    },
  },
  {
    path: '/system/permission',
    name: 'system/permission',
    component: () => import('@/views/System/AccessControl/_components/Permissions.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'AccessControl',
    },
  },
  {
    path: '/system/preferences',
    name: 'system/preferences',
    component: () => import('@/views/System/Preferences/Preferences.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/system/configuration/team',
    name: 'system/configuration/team',
    component: () => import('@/views/Configuration/ConfigTeam/ConfigTeam.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/system/configuration/self_service_screen',
    name: 'system/configuration/self_service_screen',
    component: () => import('@/views/Configuration/ConfigSelfServiceScreen/ConfigSelfServiceScreen.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/system/configuration/professional_activity',
    name: 'system/configuration/professional_activity',
    component: () => import('@/views/Configuration/ConfigProfessionalActivity/ConfigProfessionalActivity.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/system/configuration/billing',
    name: 'billing-settings',
    component: () => import('@/views/Configuration/ConfigBilling/ConfigBilling.vue'),
    meta: {
      layout: 'content',
    },
  },

  // manager area
  {
    path: '/manager',
    name: 'manager-login',
    component: () => import('@/views/manager/Login/ManagerLogin.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/manager/dashboard',
    name: 'manager-dashboard',
    component: () => import('@/views/manager/Dashboard/ManagerDashboard.vue'),
    meta: {
      layout: 'manager',
    },
  },
  {
    path: '/manager/admins',
    name: 'manager-admins',
    component: () => import('@/views/manager/Dashboard/ManagerDashboard.vue'),
    meta: {
      layout: 'manager',
    },
  },
  {
    path: '/manager/config',
    name: 'manager-config',
    component: () => import('@/views/manager/Dashboard/ManagerDashboard.vue'),
    meta: {
      layout: 'manager',
    },
  },
  {
    path: '/manager/promocoes',
    name: 'manager-promocoes',
    component: () => import('@/views/manager/Promocao/ManagerPromocoes.vue'),
    meta: {
      layout: 'manager',
    },
  },
  {
    path: '/manager/pricing',
    name: 'manager-pricing',
    component: () => import('@/views/manager/Pricing/ManagerPricing.vue'),
    meta: {
      layout: 'manager',
    },
  },
  {
    path: '/manager/help',
    name: 'manager-help',
    component: () => import('@/views/manager/Help/ManagerHelp.vue'),
    meta: {
      layout: 'manager',
    },
  },
  {
    path: '/manager/usuarios',
    name: 'manager-usuarios',
    component: () => import('@/views/manager/Usuario/ManagerUsuarios.vue'),
    meta: {
      layout: 'manager',
    },
  },

  // login
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/Login.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/Register.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/auth/google/callback',
    name: 'auth-google-callback',
    component: () => import('@/views/GoogleCallback.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/ForgotPassword.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/password-reset',
    name: 'reset-password',
    component: () => import('@/views/ResetPassword.vue'),
    meta: {
      layout: 'blank',
    },
  },

  // menssages
  {
    path: '/message',
    name: 'message',
    component: () => import('@/views/Messages/Message.vue'),
    meta: {
      layout: 'content',
    },
  },

  // Preços e planos
  {
    path: '/pricing',
    name: 'pricing',
    component: () => import('@/views/Pricing/Pricing.vue'),
    meta: {
      layout: 'content',
    },
  },

  // Assinatura
  {
    path: '/assinatura',
    name: 'assinatura',
    component: () => import('@/views/Assinatura/AssinaturaMercadoPago.vue'),
    meta: {
      layout: 'content',
    },
  },

  // Faq
  {
    path: '/faq',
    name: 'faq',
    component: () => import('@/views/Faq/Faq.vue'),
    meta: {
      layout: 'content',
    },
  },

  // Faq
  {
    path: '/profile/:tab?',
    name: 'profile',
    component: () => import('@/views/AccountSettings/AccountSettings.vue'),
    meta: {
      layout: 'content',
    },
  },
  //ROTAS DE ESTETICA
  {
    path: '/aesthetics',
    name: 'aesthetics',
    component: () => import('@/views/Aesthetics/BodyAssessment/BodyAssessment.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'Public',
    },
  },


  {
    path: '/test_pixel_tiktok',
    name: 'test_pixel_tiktok',
    component: () => import('@/views/TestPixelTikTok.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '*',
    component: () => import('@/views/Error404.vue'),

    // redirect: 'error-404',
    meta: {
      layout: 'blank',
    },
  },
]

const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const publicRoutes = [
    'landingPage',
    'policy',
    'auth-login',
    'register',
    'agora',
    'manager-login',
    'calendar/schedule',
    'external_menu/company',
    'external_menu/menu',
  ]
  const isPublic = publicRoutes.includes(to.name) || (to.meta && to.meta.layout === 'blank')

  if (!isPublic && !localStorage.getItem('access_token')) {
    Vue.$toast.clear()
    Vue.$toast.error('Login expirado')
    next({ name: 'auth-login' })
    return
  }

  if (canNavigate(to)) {
    next()

    return
  }

  next({ name: 'dashboard' })
})

export default router
